<template>
    <div>
        <el-drawer v-model="PrenatalInfoparam.view" :with-header="false" size="600" :before-close="closewindow">
            <div>
                <el-form :inline="true">
                    <el-form-item>
                    <el-date-picker
                    v-model="PrenatalInfoparam.time"
                    type="datetimerange"
                    size="large"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="PrenatalInfoparam.ischange=true"
                    />
                    </el-form-item>
                    <el-form-item>
                    <div class="TTL-input">
                    <el-input v-model="PrenatalInfoparam.key" placeholder="关键字" round size="large" prefix-icon="Search" clearable @change="PrenatalInfoparam.ischange=true"/>
                    </div>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="warning" size="large" round @click="getprenatalInfolists">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                    <el-button type="warning" size="large" round @click="addPrenatalInfo">新增</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="prenatal-main">
                <el-empty description="还没有记录" v-if="Prenatallists.length > 0 ? false : true" />
                <div class="infinite-list-wrapper" style="overflow: auto" v-if="Prenatallists.length > 0">
                    <ul class="TTL-prenatal-lists" v-loading="PrenatalInfoparam.loading">
                        <li v-for="(item, index) in Prenatallists" :key="index">
                            <div class="TTL-timeline-yunjian" v-if="item.type==1">{{ item.time }}{{ '，'+item.content }}，<span class="TTL-timeline-prices">{{ '￥'+item.price }}</span></div>
                            <div class="TTL-timeline-wenzhen" v-if="item.type==2">{{ item.time }}{{ '，'+item.content }}，<span class="TTL-timeline-prices">{{ '￥'+item.price }}</span></div>
                            <div class="TTL-timeline-yimiao" v-if="item.type==3">{{ item.time }}{{ '，'+item.content }}，<span class="TTL-timeline-prices">{{ '￥'+item.price }}</span></div>
                            <div class="TTL-timeline">{{ item.address }}</div>
                            <a class="TTL-prenatal-edit" @click="editprenatal(item)"></a>
                            <a class="TTL-prenatal-close" @click="closeprenatal(item)"></a>
                            <div class="TTL-prenatal-image" v-if="item.thumbs.length > 0">
                            <div class="TTL-prenatal-image-info" v-for="(t,i) in item.thumbs">
                            <el-image 
                            :src="t" 
                            :preview-src-list="[t]" 
                            :initial-index="1"
                            preview-teleported="true"
                            :zoom-rate="1.2" 
                            fit="cover"  
                            />
                            </div>
                            </div>
                        </li>
                    </ul>
                    <div class="block TTL-page-block" v-if="Prenatallists.length > 0">
                    <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="PrenatalInfoparam.p"
                    :page-sizes="[100, 200, 300, 400]"
                    :page-size="PrenatalInfoparam.rollpage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="PrenatalInfoparam.row"
                    />
                    </div>
                </div>
            </div>
        </el-drawer>

        <!-- 查看、新增、编辑病例 -->
        <PrenatalInfoAddOrEdit 
        :id="PrenatalInfoAddOrEdit.id"
        :value="PrenatalInfoAddOrEdit.view" 
        :memberid="PrenatalInfoAddOrEdit.memberid" 
        :type="PrenatalInfoAddOrEdit.type" 
        :hospitalid="PrenatalInfoAddOrEdit.hospitalid"
        :isbindtype="PrenatalInfoAddOrEdit.isbindtype"
        :isbindmemberid="PrenatalInfoAddOrEdit.isbindmemberid"
        @PrenatalInfoAddOrEditfinish="PrenatalInfoAddOrEditfinish" />

    </div>
</template>

<script>
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
import PrenatalInfoAddOrEdit from '@/views/Home/Module/PrenatalInfoAddOrEdit.vue';
export default {
    props: ['value','memberid','type'],
    components:{PrenatalInfoAddOrEdit},
    data() {
        return {

            /** 产检信息查询 **/
            PrenatalInfoparam: {
                time:[],
                memberid:'',
                type:1,
                view:false,
                ischange:false,
                loading:false,
                key:'',
                p:1,
                rollpage:10,
                row:0,
            },  

            /** 产检信息列表 **/
            Prenatallists:[
                {id:1,time:'2023-01-01',description:'CT彩超，脐流血、验血、唐氏筛查、吸氧CT彩超，脐流血、验血、唐氏筛查、吸氧CT彩超，脐流血、验血、唐氏筛查、吸氧',prices:200,address:'广西自治区人民医院（桃园路总院）'},
                {id:2,time:'2023-02-01',description:'吸氧、打吊瓶',prices:20,address:'南宁市江南区锦绣江南诊所'},
            ],

            /** 查看/新增/编辑病例信息 **/
            PrenatalInfoAddOrEdit: {
                view:false,
                id:'',
                memberid:'',
                hospitalid:'',
                type:1,
                isbindtype:true, //是否绑定操作类型
                isbindmemberid:true, //是否绑定家庭成员id
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.PrenatalInfoparam.view=true;
                this.PrenatalInfoparam.memberid=this.memberid;
                this.PrenatalInfoparam.type=this.type;
                this.PrenatalInfoAddOrEdit.memberid=this.memberid;
                this.PrenatalInfoAddOrEdit.type=this.type;
                this.prenatalInforeset(); //产检信息初始化设置
                this.getprenatalInfolists(); //获取产检信息列表
            }
        }
    },

    methods: {

        /** 新增问诊信息 **/
        addPrenatalInfo() {
            this.PrenatalInfoAddOrEdit.id='';
            PrenatalInfoAddOrEdit.hospitalid='';
            this.PrenatalInfoAddOrEdit.view=true;
        },

        
        /** 编辑问诊信息 **/
        editprenatal(item) {
            this.PrenatalInfoAddOrEdit.id=item.id;
            PrenatalInfoAddOrEdit.hospitalid=item.hospitalid;
            this.PrenatalInfoAddOrEdit.view=true;
        },


        /** 删除问诊信息 **/
        closeprenatal(item) {
            let id=item.id;
            this.$confirm.confirm(
                '您确定要删除该病例 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            )
            .then(()=> {
                INTERFACE_MODEL_GENEALOGY.DEL_PRENATAL({id:item.id}).then((res) => {
                    if(res.status > 0) return false;
                    this.getprenatalInfolists();
                });
            })
            .catch(()=> {
                
            });
        },


        /** 信息结束回调 **/
        PrenatalInfoAddOrEditfinish() {
            this.PrenatalInfoAddOrEdit.view=false;
            this.PrenatalInfoparam.ischange=true; 
            this.getprenatalInfolists(); //刷新列表数据
        },

        /** 获取产检信息列表 **/
        getprenatalInfolists() {
            //没有更多加载，不往下执行
            if(this.PrenatalInfoparam.isfinish) return false; 

            let _this=this;
            this.PrenatalInfoparam.loading=true;
            if(this.PrenatalInfoparam.ischange) this.PrenatalInfoparam.p=1;
            if(!this.PrenatalInfoparam.time) this.PrenatalInfoparam.time='';
            INTERFACE_MODEL_GENEALOGY.GET_MEMBER_PRENATALINFO_LIST(this.PrenatalInfoparam).then((res) => {
                this.PrenatalInfoparam.loading=false;
                if(res.status > 0) return false;
                this.Prenatallists=res.data.list;
                this.PrenatalInfoparam.row=res.data.count;
            });
        },


        /** 调整每页条数 **/
        handleSizeChange(e) {
            this.PrenatalInfoparam.rollpage=e;
            this.getprenatalInfolists();
        },


        /** 调整页数 **/
        handleCurrentChange(e) {
            this.PrenatalInfoparam.p=e;
            this.getprenatalInfolists();
        },



        /** 查询数据初始化设置 **/
        prenatalInforeset() {
            this.PrenatalInfoparam.time=[];
            this.PrenatalInfoparam.key='';
            this.PrenatalInfoparam.p=1;
            this.PrenatalInfoparam.rollpage=10;
            this.Prenatallists=[];
        },


        /** 关闭窗口 **/
        closewindow() {
            this.PrenatalInfoparam.view=false;
            this.$emit('PrenatalInfofinish');
        },


    }
}
</script>
<style scoped>
.prenatal-main {width:100%;margin-top:10px;}
.TTL-prenatal-lists {padding:0;margin:0;float:left;width:100%;}
.TTL-prenatal-lists li {float:left;width:calc(100% - 40px);padding:10px 20px;border-radius:6px;transition:.5s all;border-bottom:1px solid #F0F2F5;Position:relative;transition:.5s all;}
.TTL-timeline {padding:5px 0 5px 20px;width:calc(100% - 20px);line-height:23px;margin-bottom:5px;font-size:12px;color:#909399;background:url(@/assets/icon/address.png) no-repeat;background-size:15px;background-Position:0 center;display:flex;align-items:center; }
.TTL-timeline-yunjian,.TTL-timeline-wenzhen,.TTL-timeline-yimiao {padding:5px 30px 5px 35px;width:calc(100% - 65px);color:#606266;margin-bottom:5px;font-size:13px;}
.TTL-timeline-yunjian {background:url(@/assets/icon/check-yunjian.png) no-repeat;background-size:25px;background-position:0 center;}
.TTL-timeline-wenzhen {background:url(@/assets/icon/wenzhen.png) no-repeat;background-size:25px;background-position:0 center;}
.TTL-timeline-yimiao {background:url(@/assets/icon/yimiao.png) no-repeat;background-size:25px;background-position:0 center;}

.TTL-timeline-prices {color:#F56C6C;font-weight:550;margin-bottom:5px;font-size:13px;}
.TTL-prenatal-lists li:hover {background:#F0F2F5;}
.TTL-prenatal-image {border-top:1px solid #F0F2F5;padding:10px;width:calc(100% - 20px);}
.TTL-prenatal-image-info {float:left;width:50px;height:50px;border-radius:6px;margin-right:10px;margin-bottom:10px;overflow:hidden;}
.TTL-prenatal-close {width:25px;height:25px;Position:absolute;top:0;right:0;margin-top:15px;margin-right:10px;border-radius:50%;background:#F56C6C url(@/assets/icon/close.png) no-repeat;background-size:8px;background-position:center}
.TTL-prenatal-edit {width:25px;height:25px;Position:absolute;top:0;right:0;margin-top:15px;border-radius:50%;margin-right:40px;background:#E6A23C url(@/assets/icon/edit.png) no-repeat;background-size:12px;background-position:center;}
.TTL-page-block {float:left;width:100%;margin-top:20px;padding:20px 0;}
.TTL-page-block .el-pagination {font-size:13px !important;}
:deep(.el-empty__description) {letter-spacing:2px;font-weight:100;}
</style>